import compose from 'recompose/compose';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import * as RouteUtils from '../../../routes/utils';
import Layout from './layout';

const enhance = compose(
	withState('isHomepage', 'updateIsHomepage', false),
	lifecycle({
		componentDidMount() {
			const {props: {location: {pathname}, updateIsHomepage}} = this;

			updateIsHomepage(RouteUtils.isAdminHomepage(pathname));
		},
		componentWillReceiveProps(nextProps) {
			const {props: {location: {pathname}, updateIsHomepage}} = this;
			const {location: {pathname: newPath}} = nextProps;

			if (pathname !== newPath) {
				updateIsHomepage(RouteUtils.isAdminHomepage(newPath));
			}
		}
	}),
	withHandlers({
		handleGoBack: props => () => {
			const {location: {pathname}, history} = props;
			const route = RouteUtils.getAdminRoute(pathname);

			switch (route) {
				case RouteUtils.ADMIN_CREATE_FILE:
				case RouteUtils.ADMIN_EDIT_FILE:
					history.push(RouteUtils.ejectLast(pathname));
					break;
				case RouteUtils.ADMIN_ANALYTICS:
				case RouteUtils.ADMIN_CREATE_COLLECTION:
				case RouteUtils.ADMIN_EDIT_COLLECTION:
				case RouteUtils.ADMIN_LIST_FILES:
				default:
					history.push('/admin');
			}
		}
	})
);

export default enhance(Layout);



// WEBPACK FOOTER //
// ./src/client/components/admin/layout/index.js